var _defs, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneralClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_26180",
    "data-name": "Group 26180",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 151.797,
    height: 151.797,
    viewBox: "0 0 151.797 151.797",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: -0.074,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#d286ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#8a19ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopColor: "#6e14a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#480971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#6e14a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#974dc4",
    stopOpacity: 0.635
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refresh"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_67",
    "data-name": "Ellipse 67",
    cx: 75.898,
    cy: 75.898,
    rx: 75.898,
    ry: 75.898,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_67_-_Outline",
    "data-name": "Ellipse 67 - Outline",
    d: "M75.9,4.744A71.155,71.155,0,0,0,25.584,126.213,71.155,71.155,0,0,0,126.213,25.584,70.689,70.689,0,0,0,75.9,4.744M75.9,0A75.9,75.9,0,1,1,0,75.9,75.9,75.9,0,0,1,75.9,0Z",
    fill: "#ffd055"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-close",
    "data-name": "Icon ionic-ios-close",
    d: "M50.676,43.125,73.423,20.378a5.33,5.33,0,0,0-7.538-7.538L43.138,35.587,20.391,12.84a5.33,5.33,0,1,0-7.538,7.538L35.6,43.125,12.853,65.872a5.33,5.33,0,0,0,7.538,7.538L43.138,50.663,65.885,73.41a5.33,5.33,0,0,0,7.538-7.538Z",
    transform: "translate(32.769 32.774)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralClose);
export default __webpack_public_path__ + "static/media/general-close.7e1ec221df08a780642c15338bf0269b.svg";
export { ForwardRef as ReactComponent };